import useResources from "./use-resources";
// @ts-expect-error pure js
import useAuthenticatedAxios from "./use-authenticated-axios";
import type { TableauAmortissement } from "../models/tableauAmortissement";

const ROOT_PATH = "tableaux-amortissement";

interface UseTableauxAmortissementOptions {
  profileBailleurId?: number;
}

export default function useTableauxAmortissement({
  profileBailleurId,
}: UseTableauxAmortissementOptions = {}) {
  const axios = useAuthenticatedAxios();

  const {
    resources: tableaux,
    error,
    isLoading,
    create,
    update,
    del,
    mutate,
  } = useResources<TableauAmortissement>(ROOT_PATH, {
    params: {
      id_profile_bailleur: profileBailleurId,
    },
  });

  async function regenererTableau(tableauId: number) {
    const response = await axios.post(`${ROOT_PATH}/${tableauId}/regenerer`);
    mutate();
    return response.data;
  }

  return {
    tableaux,
    error,
    isLoading,
    createTableau: create,
    updateTableau: update,
    deleteTableau: del,
    regenererTableau,
    mutate,
  };
}
